import type { RouteRecordRaw } from 'vue-router'
import {
  goalRouteCandidates,
  toAnyPermission,
} from '@/config/businessRoutePermissions'

const goalRoutes: RouteRecordRaw[] = [
  {
    path: 'goals',
    component: () => import('@/views/goal/GoalLayout.vue'),
    meta: {
      permission: toAnyPermission(goalRouteCandidates),
      defaultRouteBasePath: '/goals',
      defaultRouteCandidates: goalRouteCandidates,
    },
    children: [
      {
        path: 'okr',
        name: 'okr-management',
        component: () => import('@/views/goal/OKRManagement.vue'),
        meta: { permission: 'goal:okr:view' }
      },
      {
        path: 'weekly',
        name: 'weekly-goals',
        component: () => import('@/views/goal/WeeklyGoalManagement.vue'),
        meta: { permission: 'goal:record:view' }
      },
      {
        path: 'daily',
        name: 'daily-goals',
        component: () => import('@/views/goal/DailyGoalManagement.vue'),
        meta: { permission: 'goal:record:view' }
      },
      {
        path: 'review',
        name: 'okr-review',
        component: () => import('@/views/goal/OKRReviewList.vue'),
        meta: { permission: 'goal:okr:view' }
      },
      {
        path: 'review/:id',
        name: 'okr-review-detail',
        component: () => import('@/views/goal/OKRReviewDetail.vue'),
        meta: { permission: 'goal:okr:view' }
      },
      {
        path: 'dashboard',
        name: 'goal-dashboard',
        component: () => import('@/views/goal/GoalDashboard.vue'),
        meta: { permission: 'goal:record:view' }
      }
    ]
  }
]

export default goalRoutes
